import { Component, HostListener, OnInit, Pipe } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-docter-info',
  templateUrl: './docter-info.component.html',
  styleUrls: ['./docter-info.component.scss']
})
export class DocterInfoComponent implements OnInit {
  doctor: any = {};
  currentYear!: number;
  isMobileScreen: boolean = false;
  hasNonEmptyEducationAndWorkExperience: boolean = false;
  canSlideLeftSpecialities: boolean = false;
  canSlideRightSpecialities: boolean = true;
  private contributionsContainer: HTMLElement | null = null;
  private resizeObserver: ResizeObserver | null = null;


  constructor(
    private route: ActivatedRoute,
    private endCustomerService: EndCustomerService,
    private spinnerService: SpinnerService
  ) {
    this.currentYear = new Date().getFullYear();
  }

  async ngOnInit(): Promise<void> {
    this.checkScreenSize();
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    this.resizeObserver = new ResizeObserver(() => {
      this.updateScrollState();
    });
    this.route.paramMap.subscribe(async (params) => {
      const doctorId = params.get('id');
      if (doctorId) {
        this.spinnerService.showSpinner();
        await this.getDoctorById(doctorId);
      }
    });
    this.doctor.publications = [];

    this.doctor.moreInfos?.forEach((info: any) => {
      if (info?.publications?.length) {
        this.doctor.publications.push(...info.publications);
      }
    });

    this.doctor.publications = (this.doctor.publications || [])
      .filter((publication: any) => publication?.publicationDate)
      .sort((a: any, b: any) => new Date(b.publicationDate).getTime() - new Date(a.publicationDate).getTime());

    this.doctor.awards = [];
    this.doctor.moreInfos?.forEach((info: any) => {
      if (info?.awards?.length) {
        this.doctor.awards.push(...info.awards);
      }
    });
    this.doctor.awards = (this.doctor.awards || [])
      .filter((award: any) => award?.awardDate)
      .sort((a: any, b: any) =>{ 
        const dataB =new Date(b.awardDate).getTime() 
         const dataA = new Date(a.awardDate).getTime()
        return dataB - dataA;
      });

    this.doctor.courseTrainings = [];
    this.doctor.moreInfos?.forEach((info: any) => {
      if (info?.courseTrainings?.length) {
        this.doctor.courseTrainings.push(...info.courseTrainings);
      }
    });
    this.doctor.courseTrainings = (this.doctor.courseTrainings || [])
      .filter((course: any) => course?.courseDate)
      .sort((a: any, b: any) =>{
        const dataB = new Date(b.courseDate).getTime() 
        const dataA= new Date(a.courseDate).getTime()
        return dataB - dataA;});

    this.doctor.volunteerings = [];
    this.doctor.moreInfos?.forEach((info: any) => {
      if (info?.volunteerings?.length) {
        this.doctor.volunteerings.push(...info.volunteerings);
      }
    });    
    this.doctor.volunteerings = (this.doctor.volunteerings || []) 
      .filter((volunteer: any) => volunteer?.fromDate)
      .sort((a: any, b: any) =>{
        const dataB=new Date(b.fromDate).getTime();
        const dataA= new Date(a.fromDate).getTime();
        return dataB - dataA;
      });   
    
    this.doctor.associations=[];
      this.doctor.moreInfos?.forEach((info: any)=>{
        if(info?.associations?.length) {
          this.doctor.associations.push(...info.associations);
        }
      });
      this.doctor.associations = (this.doctor.associations || [])
      .filter((association: any) => association?.fromDate)
      .sort((a: any, b: any) =>{
        const dataB = new Date(b?.fromDate).getTime();
        const dataA = new Date(a?.fromDate).getTime();
        return dataB - dataA;
      });
  }

  async getDoctorById(doctorId: any) {
      try {
        const doctorResponse = await this.endCustomerService.hospitalDetails(doctorId).toPromise();
        if (doctorResponse.statusCode === '200 OK') {

          const data = doctorResponse?.data;
          this.doctorid = doctorResponse?.data?.id
          this.doctorAccountType = doctorResponse?.data?.account?.name;

          this.doctor = {
            name: data.name,
            specialty: data?.position?.name,
            workingIn: data?.workingIn,
            description: data?.aboutId?.about,
            twitterUrl: data?.aboutId?.twitterUrl,
            instagramUrl: data?.aboutId?.instagramUrl,
            linkedin: data?.aboutId?.linkedin,
            facebookUrl: data?.aboutId?.facebookUrl,
            educationInfos: data?.educationInfos || [],
            workInfos: data?.workInfos || [],
            services: [],
            image: data?.logo,
            phoneCode: data?.phoneCode,
            phone: data?.phone,
            email: data?.email,
            certifications: data?.certifications || [],
            moreInfos: data?.moreInfos || [],
            qrCode: data?.qrCodeURL,
            url: data?.url,
            certificates: data?.certifications?.slice(0, 5),
            publications: [],
            awards: [],
            courseTrainings: [],
            volunteerings: [],
            associations: []
          };
          this.doctor.educationInfos = this.doctor.educationInfos?.sort((a: any, b: any) => b.yearTo - a.yearTo);

          this.doctor.workInfos = this.doctor.workInfos?.map((d: any) => {
            const yearFrom = this.convertTimeStampToDate(d.fromDate);
            const yearTo = this.convertTimeStampToDate(d.toDate);
            return {
              ...d,
              yearFrom: yearFrom.year,
              yearTo: yearTo.year,
              monthFrom: yearFrom.month,
              monthTo: yearTo.month
            }
          })
          this.doctor.workInfos = this.doctor.workInfos?.sort((a: any, b: any) => (b.yearTo || 0) - (a.yearTo || 0));

        if (data?.moreInfos) {
          data.moreInfos.forEach((info: any) => {
            if (info?.publications?.length) {
              this.doctor.publications.push(...info.publications);
            }
          });
        }
        
        this.doctor.publications = (this.doctor.publications || [])
          .filter((publication: any) => publication?.publicationDate)
          .sort((a: any, b: any) => new Date(b.publicationDate).getTime() - new Date(a.publicationDate).getTime());

        if (data?.moreInfos) {
          data.moreInfos.forEach((info: any) => {
            if (info?.awards?.length) {
              this.doctor.awards.push(...info.awards);
            }
          });
        }
        
        this.doctor.awards = (this.doctor.awards || [])
          .filter((award: any) => award?.awardDate)
          .sort((a: any, b: any) => { 
            const dataB = new Date(b.awardDate).getTime();
            const dataA = new Date(a.awardDate).getTime();
            return dataB - dataA;
          });

        if (data?.moreInfos) {
          data.moreInfos.forEach((info: any) => {
            if (info?.courseTrainings?.length) {
              this.doctor.courseTrainings.push(...info.courseTrainings);
            }
          });
        }
        
        this.doctor.courseTrainings = (this.doctor.courseTrainings || [])
          .filter((course: any) => course?.courseDate)
          .sort((a: any, b: any) => {
            const dataB = new Date(b.courseDate).getTime();
            const dataA = new Date(a.courseDate).getTime();
            return dataB - dataA;
          });

        if (data?.moreInfos) {
          data.moreInfos.forEach((info: any) => {
            if (info?.volunteerings?.length) {
              this.doctor.volunteerings.push(...info.volunteerings);
            }
          });
        }
        
        this.doctor.volunteerings = (this.doctor.volunteerings || [])
          .filter((volunteer: any) => volunteer?.fromDate)
          .sort((a: any, b: any) => {
            const dataB = new Date(b.fromDate).getTime();
            const dataA = new Date(a.fromDate).getTime();
            return dataB - dataA;
          });

        if (data?.moreInfos) {
          data.moreInfos.forEach((info: any) => {
            if (info?.associations?.length) {
              this.doctor.associations.push(...info.associations);
            }
          });
        }
        
        this.doctor.associations = (this.doctor.associations || [])
          .filter((association: any) => association?.fromDate)
          .sort((a: any, b: any) => {
            const dataB = new Date(b?.fromDate).getTime();
            const dataA = new Date(a?.fromDate).getTime();
            return dataB - dataA;
          });

          try{
          const skillsResponse = await this.endCustomerService.getSkills().toPromise();
          if (skillsResponse.statusCode === '200 OK') {
            const allSkills = skillsResponse.data;

            const doctorSkills = data?.skillSets?.map((skillInfo: any) => {
              const skill = allSkills.find((s: any) => s.id === skillInfo.skillsetInfoId);
              return skill ? skill.name : null;
            }).filter((skill: any) => skill !== null);

            this.doctor.skills = doctorSkills;
          }} catch (error) {
            console.error("Error fetching skills:", error);
          }

          try{
          const specialtiesResponse = await this.endCustomerService.getSpecialities().toPromise();
          if (specialtiesResponse.statusCode === '200 OK') {
            const allSpecialties = specialtiesResponse.data;

            const doctorSpecialties = data?.specialityInfos.map((specialityInfo: any) => {
              const specialty = allSpecialties.find((s: any) => s.id === specialityInfo.specialityInfoId);
              return specialty ? specialty : null;
            }).filter((specialty: any) => specialty !== null);
            this.doctor.services = doctorSpecialties;
          } } catch (error) {
            console.error("Error fetching specialties:", error);
          }

          if (this.doctor?.qrCode === undefined) {
            this.spinnerService.showSpinner();
            this.generateQRCode();
            this.spinnerService.hideSpinner();
          }
          this.hasNonEmptyEducationAndWorkExperience = this.doctor && (
            this.doctor?.educationInfos?.length !== 0 || this.doctor?.workInfos?.length !== 0 || 
            this.doctor?.skills?.length !== 0 || this.doctor?.certificates?.length !== 0 || this.doctor?.services?.length !== 0);
        }
      } catch (error) {
        console.error("Error fetching doctor details:", error);
      } finally {
        this.spinnerService.hideSpinner();
      }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobileScreen = window.innerWidth <= 600;
  }

  sColor: string = 'rgba(148, 199, 67, 1)';
  cColor: string = 'white';

  comprehensive(type: string) {
    if (type === 's') {
      this.sColor = 'rgba(148, 199, 67, 1)';
      this.cColor = 'white'
    }
    else {
      this.cColor = 'rgba(148, 199, 67, 1)';
      this.sColor = 'white'
    }
  }
  doctorid!: any
  doctorAccountType!: any;

  generateQRCode() {
    const data = {
      id: this.doctorid,
      accountType: this.doctorAccountType.trim()
    }
    this.endCustomerService.generateQRCode(data).subscribe((res: any) => {
      this.doctor.qrCode = res;
    })
  }
  openGmail() {
    const recipientEmail = this.doctor?.email;
    const mailtoLink = `mailto:${recipientEmail}`;
    window.open(mailtoLink, '_self');
  }
  openDialPad() {
    const phoneNumber = this.doctor?.phone;
    const dialPadLink = `tel:${phoneNumber}`;
    window.open(dialPadLink);
  }
  checkLink(url: string): boolean {
    return url?.startsWith('https://') || url?.startsWith('http.');
  }
  formattedUrl(url: string): string {
    if (!url) {
      return '';
    }
    return this.checkLink(url) ? url : `https://${url}`;
  }
  openInNewTab(url: string) {
    if (url === '' || url === null || url === undefined) {
      Swal.fire({
        position: 'center',
        title: '',
        width: '300px',
        text: 'To Be Updated Soon',
        iconHtml: '<img src="./assets/images/group-delete.svg">',
        iconColor: 'white',
        showConfirmButton: true,
        confirmButtonText: 'OK',
        confirmButtonColor: '#0f74a9',
      });
    } else {
      const linkUrl = this.checkLink(url) ? url : `https://${url}`;
      window.open(linkUrl, '_blank');
    }
  }
  convertTimeStampToDate(timestamp: any): any {
    if (timestamp != null && timestamp != undefined) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.toLocaleString('default', { month: 'short' });
      const day = date.getDate();
      return { year, month, day };
    } else {
      return { year: null, month: null, day: null };
    }
  }

  formattedTilteCase(value: any) {

    if (!value) return value;

    const words = value.split(' ');
    const insideParenthesesRegex = /\(([^)]+)\)/g;

    const result = words.map((word: string, index: number, arr: string[]) => {
      if (insideParenthesesRegex.test(word)) {
        return word;
      }
      if (this.isAbbreviation(word)) {
        return word;
      }

      let wordWithoutPunctuation = word.replace(/[^\w\s]/g, '');
      let punctuation = word.replace(/\w/g, '');

      if (index === 0 || index === arr.length - 1) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return wordWithoutPunctuation.charAt(0).toUpperCase() + wordWithoutPunctuation.slice(1).toLowerCase() + punctuation;
    }).join(' ');
    return result;
  }

  isAbbreviation(word: any) {
    return /^[A-Z](\.[A-Z])+$/.test(word);
  }
  getInitial(name: string): string {
    if (!name) return '';
    const cleanedName = name.replace(/^Dr\.?\s+/, '');

    return cleanedName.charAt(0).toUpperCase();
  }

ngAfterViewInit(): void {
  this.contributionsContainer = document.querySelector('.contributions') as HTMLElement;
  
  if (this.contributionsContainer) {
    if (this.resizeObserver) {
      this.resizeObserver.observe(this.contributionsContainer);
    }
    
    this.updateScrollState();
    
    const leftArrow = document.getElementById('left-arrow');
    const rightArrow = document.getElementById('right-arrow');
    
    if (leftArrow && rightArrow) {
      leftArrow.style.display = 'block';
      leftArrow.style.visibility = 'visible';
      rightArrow.style.display = 'block';
      rightArrow.style.visibility = 'visible';
    }
  }
}

ngOnDestroy(): void {
  if (this.resizeObserver && this.contributionsContainer) {
    this.resizeObserver.unobserve(this.contributionsContainer);
    this.resizeObserver.disconnect();
  }
}

slide(direction: 'left' | 'right', containerId: string): void {
  if (!this.contributionsContainer) {
    console.warn('Contributions container not found');
    return;
  }

  const containerWidth = this.contributionsContainer.clientWidth;
  const cardWidth = 330; 
  const gap = 15; 
  const fullCardWidth = cardWidth + gap;
  
  const visibleCards = this.getVisibleCardsCount();
  
  const scrollAmount = visibleCards * fullCardWidth;

  const currentScroll = this.contributionsContainer.scrollLeft;

  if (direction === 'left') {
    this.contributionsContainer.scrollTo({
      left: currentScroll - scrollAmount,
      behavior: 'smooth'
    });
  } else {
    this.contributionsContainer.scrollTo({
      left: currentScroll + scrollAmount,
      behavior: 'smooth'
    });
  }
  setTimeout(() => this.updateScrollState(), 400);
}

updateScrollState(): void {
  if (!this.contributionsContainer) return;
  const container = this.contributionsContainer;
  const scrollLeft = container.scrollLeft;
  const maxScroll = container.scrollWidth - container.clientWidth;
  const cardElements = container.querySelectorAll('.doctor-publications');
  const totalCards = cardElements.length;
  const visibleCards = this.getVisibleCardsCount();
  this.canSlideLeftSpecialities = scrollLeft > 10; 
  this.canSlideRightSpecialities = totalCards > visibleCards && scrollLeft < maxScroll - 10;
  
  const leftArrow = document.getElementById('left-arrow');
  const rightArrow = document.getElementById('right-arrow');
  
  if (leftArrow) {
    leftArrow.classList.toggle('disabled', !this.canSlideLeftSpecialities);
  }
  
  if (rightArrow) {
    rightArrow.classList.toggle('disabled', !this.canSlideRightSpecialities);
  }
}

getVisibleCardsCount(): number {
  const screenWidth = window.innerWidth;
    
    if (screenWidth <= 500) {
      return 1;
    } else if (screenWidth <= 768) {
      return 2;
    } else if (screenWidth <= 1280) {
      return 3; 
    } else if (screenWidth <= 1536){
      return 4; 
    } else {
      return 5;
    }
  }  
}